/*!
 * Calculadora de tallas — Cacles Barefoot
 * © 2026 Cacles Barefoot. Todos los derechos reservados.
 *
 * Este código es propiedad de Cacles Barefoot y ha sido desarrollado
 * específicamente para su tienda. Queda prohibida su reproducción,
 * distribución, modificación o uso, total o parcial, sin autorización
 * previa y por escrito del titular.
 * ============================================================ */
(function () {
"use strict";
var MARGEN_LARGO_MIN = 0.8;
var MARGEN_LARGO_MAX = 1.4;
var MARGEN_ANCHO_MIN = 0.2;
var MARGEN_ANCHO_MAX = 0.6;
function norm(txt) {
return (txt || "").toString().trim().toLowerCase();
}
function parseNumero(txt) {
if (txt == null) return null;
var s = txt.toString().trim().replace(/cm|mm/gi, "").trim();
s = s.replace(",", ".");
var m = s.match(/-?\d+(\.\d+)?/);
return m ? parseFloat(m[0]) : null;
}
function leerMargenesTexto(raiz) {
var texto = (raiz.body ? raiz.body.textContent : raiz.textContent) || "";
var resultado = {};
var re = /(\d+[.,]\d+)\s*(?:cm)?\s*(?:a|y|hasta|-)\s*(?:m[aá]ximo\s+)?(\d+[.,]\d+)\s*cm/gi;
var m;
while ((m = re.exec(texto)) !== null) {
var desde = Math.max(0, m.index - 80);
var hasta = Math.min(texto.length, m.index + m[0].length + 80);
var ventana = texto.slice(desde, hasta).toLowerCase();
var centro = m.index - desde;
var distAncho = distanciaMasCercana(ventana, /anch/g, centro);
var distLargo = distanciaMasCercana(ventana, /largo|longitud|sobrante/g, centro);
if (distAncho === Infinity && distLargo === Infinity) continue;
var v1 = parseFloat(m[1].replace(",", "."));
var v2 = parseFloat(m[2].replace(",", "."));
if (isNaN(v1) || isNaN(v2)) continue;
var min = Math.min(v1, v2), max = Math.max(v1, v2);
if (distAncho < distLargo) {
if (resultado.anchoMin == null) { resultado.anchoMin = min; resultado.anchoMax = max; }
} else {
if (resultado.largoMin == null) { resultado.largoMin = min; resultado.largoMax = max; }
}
}
return resultado;
}
function distanciaMasCercana(texto, regex, posicion) {
var mejor = Infinity, m;
while ((m = regex.exec(texto)) !== null) {
mejor = Math.min(mejor, Math.abs(m.index - posicion));
}
return mejor;
}
function leerMargenes(tablaEl, margenesTexto) {
margenesTexto = margenesTexto || {};
var contenedor = tablaEl.closest("[data-margen-largo-min]");
function leer(nombre, porDefectoTexto, porDefecto) {
if (contenedor) {
var v = parseFloat(contenedor.getAttribute(nombre));
if (!isNaN(v)) return v;
}
return porDefectoTexto != null ? porDefectoTexto : porDefecto;
}
return {
largoMin: leer("data-margen-largo-min", margenesTexto.largoMin, MARGEN_LARGO_MIN),
largoMax: leer("data-margen-largo-max", margenesTexto.largoMax, MARGEN_LARGO_MAX),
anchoMin: leer("data-margen-ancho-min", margenesTexto.anchoMin, MARGEN_ANCHO_MIN),
anchoMax: leer("data-margen-ancho-max", margenesTexto.anchoMax, MARGEN_ANCHO_MAX)
};
}
function clasificarHorma(largo, ancho) {
var ratio = largo / ancho;
if (largo <= 13) {
if (ratio <= 2.15) return "ancho";
if (ratio <= 2.3) return "medio";
return "estrecho";
}
if (largo <= 16) {
if (ratio <= 2) return "muy ancho";
if (ratio <= 2.25) return "ancho";
if (ratio <= 2.5) return "medio";
return "estrecho";
}
if (largo <= 20) {
if (ratio <= 2.2) return "muy ancho";
if (ratio <= 2.4) return "ancho";
if (ratio <= 2.65) return "medio";
return "estrecho";
}
if (ratio <= 2.4) return "muy ancho";
if (ratio <= 2.6) return "ancho";
return "medio";
}
function detectarColumnas(filaCeldas) {
var col = { talla: -1, largo: -1, anchos: [] };
filaCeldas.forEach(function (celda, i) {
var t = norm(celda.textContent);
if (col.talla === -1 && t.indexOf("talla") !== -1) col.talla = i;
if (col.largo === -1 && (t.indexOf("largo") !== -1 || t.indexOf("longitud") !== -1)) col.largo = i;
if (t.indexOf("anch") !== -1) col.anchos.push({ index: i, header: celda.textContent.trim() });
});
return col;
}
function encontrarTablasDeTallas(raiz) {
raiz = raiz || document;
var tablas = [];
raiz.querySelectorAll("table").forEach(function (tabla) {
var filas = Array.prototype.slice.call(tabla.querySelectorAll("tr"));
for (var i = 0; i < filas.length; i++) {
var celdas = Array.prototype.slice.call(filas[i].querySelectorAll("th,td"));
var col = detectarColumnas(celdas);
if (col.talla !== -1 && col.largo !== -1) {
tablas.push({ tabla: tabla, headerRowIndex: i, columnas: col });
break;
}
}
});
return tablas;
}
function extraerFilas(info) {
var filas = Array.prototype.slice.call(info.tabla.querySelectorAll("tr"));
var datos = [];
for (var i = info.headerRowIndex + 1; i < filas.length; i++) {
var celdas = Array.prototype.slice.call(filas[i].querySelectorAll("th,td"));
if (!celdas.length) continue;
var talla = parseNumero(celdas[info.columnas.talla] && celdas[info.columnas.talla].textContent);
var largo = parseNumero(celdas[info.columnas.largo] && celdas[info.columnas.largo].textContent);
var anchos = info.columnas.anchos.map(function (a) {
return { header: a.header, valor: parseNumero(celdas[a.index] && celdas[a.index].textContent) };
});
if (talla == null || largo == null) continue;
datos.push({ talla: talla, largo: largo, anchos: anchos, filaEl: filas[i] });
}
return datos;
}
function extraerEtiquetaTabla(info, indice) {
if (info.headerRowIndex > 0) {
var filas = Array.prototype.slice.call(info.tabla.querySelectorAll("tr"));
var celdasPrevias = Array.prototype.slice.call(filas[info.headerRowIndex - 1].querySelectorAll("th,td"));
var textos = celdasPrevias.map(function (c) { return (c.textContent || "").trim(); }).filter(Boolean);
if (textos.length === 1 && textos[0].length >= 2 && textos[0].length <= 60) {
return textos[0];
}
}
var nodo = info.tabla.previousElementSibling;
var intentos = 0;
while (nodo && intentos < 6) {
var texto = (nodo.textContent || "").replace(/\s+/g, " ").trim();
if (texto && texto.length >= 2 && texto.length <= 60) {
return texto;
}
nodo = nodo.previousElementSibling;
intentos++;
}
return "Guía " + indice;
}
function crearWidget(grupos, margenesTexto, destino) {
grupos = grupos.filter(function (g) { return g.datos.length > 0; });
if (!grupos.length) return null;
var wrapper = document.createElement("div");
wrapper.className = "cbf-calc-tallas";
wrapper.style.cssText =
"border:1px solid #ddd;border-radius:8px;padding:16px;margin:16px 0;font-family:inherit;max-width:420px;";
var selectorGuiaHtml = "";
if (grupos.length > 1) {
var opcionesGuia = grupos.map(function (g, idx) {
return '<option value="' + idx + '">' + g.etiqueta + "</option>";
}).join("");
selectorGuiaHtml =
'<label style="display:block;margin-bottom:10px;">Guía<br>' +
'<select class="cbf-guia" style="margin-top:4px;">' + opcionesGuia + "</select></label>";
}
var lineaInstrucciones =
'<p style="margin:10px 0 0;">' +
'<a href="/pages/medir-el-pie" target="_blank" rel="noopener" style="display:block;font-size:0.85em;color:#71984A;text-decoration:underline;margin-bottom:6px;">📐 Cómo medir tu pie</a>' +
'<a href="/pages/como-saber-si-el-pie-es-ancho-medio-o-estrecho" target="_blank" rel="noopener" style="display:block;font-size:0.85em;color:#71984A;text-decoration:underline;margin-bottom:6px;">📏 ¿Ancho, medio o estrecho?</a>' +
'<a href="/pages/como-funciona-la-calculadora-de-tallas" target="_blank" rel="noopener" style="display:block;font-size:0.85em;color:#71984A;text-decoration:underline;">ℹ️ ¿Cómo funciona esta calculadora?</a>' +
"</p>";
wrapper.innerHTML =
'<p style="margin:0 0 10px;font-weight:bold;">📏 Calculadora de tallas</p>' +
selectorGuiaHtml +
'<div class="cbf-cuerpo"></div>' +
lineaInstrucciones;
var cuerpo = wrapper.querySelector(".cbf-cuerpo");
var selectGuia = wrapper.querySelector(".cbf-guia");
function renderGrupo(grupo) {
var info = grupo.info;
var datos = grupo.datos;
var numAnchos = info.columnas.anchos.length;
var tieneAncho = numAnchos > 0;
var lineaHorma = "";
if (tieneAncho) {
var conAncho = datos.filter(function (d) { return d.anchos[0] && d.anchos[0].valor != null; });
if (conAncho.length) {
var filaIntermedia = conAncho[Math.floor(conAncho.length / 2)];
var horma = clasificarHorma(filaIntermedia.largo, filaIntermedia.anchos[0].valor);
lineaHorma = '<p style="margin:0 0 12px;">Este calzado es para pie <strong>' + horma + '</strong>.</p>';
}
}
var campoAncho = "";
if (tieneAncho) {
var selectorHorma = "";
if (numAnchos > 1) {
var opciones = info.columnas.anchos.map(function (a, idx) {
return '<option value="' + idx + '">' + a.header + "</option>";
}).join("");
selectorHorma =
'<label style="display:block;margin-bottom:8px;">Horma<br>' +
'<select class="cbf-horma" style="margin-top:4px;">' + opciones + "</select></label>";
}
campoAncho =
selectorHorma +
'<label style="display:block;">Ancho de tu pie (cm)<br>' +
'<input type="number" step="0.1" class="cbf-ancho" style="width:80px;margin-top:4px;"></label>';
}
cuerpo.innerHTML =
lineaHorma +
'<div style="display:flex;flex-wrap:wrap;gap:12px;margin-bottom:10px;">' +
'<label style="display:block;">Largo de tu pie (cm)<br>' +
'<input type="number" step="0.1" class="cbf-largo" style="width:80px;margin-top:4px;"></label>' +
campoAncho +
"</div>" +
'<button type="button" class="cbf-btn" style="padding:8px 14px;cursor:pointer;font-family:\'Poppins\',sans-serif;">Calcular mi talla</button>' +
'<p class="cbf-resultado" style="margin-top:10px;font-weight:bold;"></p>';
var inputLargo = cuerpo.querySelector(".cbf-largo");
var inputAncho = cuerpo.querySelector(".cbf-ancho");
var selectHorma = cuerpo.querySelector(".cbf-horma");
var boton = cuerpo.querySelector(".cbf-btn");
var resultadoEl = cuerpo.querySelector(".cbf-resultado");
function resaltar(d, activo) {
d.filaEl.style.backgroundColor = activo ? "#e2ead9" : "";
if (activo && d.filaEl.isConnected) {
d.filaEl.scrollIntoView({ behavior: "smooth", block: "center" });
}
}
function limpiarResaltado() {
datos.forEach(function (d) {
d.filaEl.style.backgroundColor = "";
});
}
function calcular() {
limpiarResaltado();
var largoPie = parseFloat(inputLargo.value);
var anchoTexto = inputAncho ? inputAncho.value.trim() : "";
var anchoPie = anchoTexto === "" ? null : parseFloat(anchoTexto);
if (isNaN(largoPie) || largoPie <= 0) {
resultadoEl.style.color = "#c0392b";
resultadoEl.textContent = "Introduce al menos el largo de tu pie.";
return;
}
var margenes = leerMargenes(info.tabla, margenesTexto);
var largoMin = largoPie + margenes.largoMin;
var largoMax = largoPie + margenes.largoMax;
var conLargoEnRango = datos.filter(function (d) {
return d.largo >= largoMin && d.largo <= largoMax;
});
if (anchoPie == null || isNaN(anchoPie) || anchoPie <= 0) {
if (!conLargoEnRango.length) {
resultadoEl.style.color = "#c0392b";
resultadoEl.textContent = "No tenemos una talla con el margen de largo adecuado para tu pie en este modelo.";
return;
}
conLargoEnRango.sort(function (a, b) {
return (a.largo - largoPie) - (b.largo - largoPie);
});
var porLargo = conLargoEnRango[0];
resultadoEl.style.color = "#71984A";
resultadoEl.innerHTML =
"Por longitud, tu talla recomendada es la " + porLargo.talla + ". " +
'<span style="font-weight:normal;">Recuerda que para que un calzado sea realmente respetuoso con tu pie debes tener en cuenta también el ancho.</span>';
resaltar(porLargo, true);
return;
}
var anchoMin = anchoPie + margenes.anchoMin;
var anchoMax = anchoPie + margenes.anchoMax;
var indiceHorma = selectHorma ? parseInt(selectHorma.value, 10) : 0;
var candidatas = conLargoEnRango.filter(function (d) {
var a = d.anchos[indiceHorma] && d.anchos[indiceHorma].valor;
return a != null && a >= anchoMin && a <= anchoMax;
});
if (candidatas.length) {
candidatas.sort(function (a, b) {
return (a.largo - largoPie) - (b.largo - largoPie);
});
var opcionAjustada = candidatas[0];
var opcionHolgada = candidatas[candidatas.length - 1];
resultadoEl.style.color = "#71984A";
limpiarResaltado();
if (candidatas.length === 1 || opcionAjustada.talla === opcionHolgada.talla) {
resultadoEl.textContent = "Tu talla recomendada es la " + opcionAjustada.talla;
resaltar(opcionAjustada, true);
} else {
resultadoEl.innerHTML =
"Talla " + opcionAjustada.talla + " &mdash; menor margen de largo (" +
(opcionAjustada.largo - largoPie).toFixed(1) + " cm de holgura)<br>" +
"Talla " + opcionHolgada.talla + " &mdash; mayor margen de largo (" +
(opcionHolgada.largo - largoPie).toFixed(1) + " cm de holgura)<br>" +
'<span style="font-weight:normal;font-size:0.9em;">Elige según tu preferencia de espacio sobrante.</span>';
resaltar(opcionAjustada, true);
resaltar(opcionHolgada, true);
}
return;
}
resultadoEl.style.color = "#c0392b";
if (conLargoEnRango.length === 0) {
resultadoEl.textContent = "No tenemos una talla con el margen de largo adecuado para tu pie en este modelo.";
return;
}
var demasiadoEstrecho = conLargoEnRango.some(function (d) {
var a = d.anchos[indiceHorma] && d.anchos[indiceHorma].valor;
return a != null && a < anchoMin;
});
var demasiadoAncho = conLargoEnRango.some(function (d) {
var a = d.anchos[indiceHorma] && d.anchos[indiceHorma].valor;
return a != null && a > anchoMax;
});
if (demasiadoEstrecho && !demasiadoAncho) {
resultadoEl.textContent = "Zapato demasiado estrecho para tu pie.";
} else if (demasiadoAncho && !demasiadoEstrecho) {
resultadoEl.textContent = "Zapato demasiado ancho para tu pie.";
} else {
resultadoEl.textContent = "No hay una talla con el ancho adecuado para tu pie en este modelo.";
}
}
boton.addEventListener("click", calcular);
[inputLargo, inputAncho].filter(Boolean).forEach(function (el) {
el.addEventListener("keydown", function (e) {
if (e.key === "Enter") calcular();
});
});
}
renderGrupo(grupos[0]);
if (selectGuia) {
selectGuia.addEventListener("change", function () {
renderGrupo(grupos[parseInt(selectGuia.value, 10)]);
});
}
if (destino) {
destino.appendChild(wrapper);
}
return wrapper;
}
function iniciarEnPagina() {
var tablas = encontrarTablasDeTallas();
if (!tablas.length) return;
try {
var grupos = tablas.map(function (info, i) {
return { info: info, datos: extraerFilas(info), etiqueta: extraerEtiquetaTabla(info, i + 1) };
});
var margenesTexto = leerMargenesTexto(document);
var widget = crearWidget(grupos, margenesTexto);
if (widget) {
tablas[0].tabla.parentNode.insertBefore(widget, tablas[0].tabla);
}
} catch (e) {
console.warn("Calculadora de tallas: error en modo página (no afecta al modo producto).", e);
}
}
function iniciarRemoto() {
var contenedores = document.querySelectorAll(".cbf-calc-remoto[data-guia-url]");
contenedores.forEach(function (contenedor) {
var url = contenedor.getAttribute("data-guia-url");
if (!url) return;
fetch(url)
.then(function (r) {
if (!r.ok) throw new Error("No se pudo cargar la guía de tallas (" + r.status + ")");
return r.text();
})
.then(function (html) {
var docExterno = new DOMParser().parseFromString(html, "text/html");
var tablas = encontrarTablasDeTallas(docExterno);
if (!tablas.length) return;
var grupos = tablas.map(function (info, i) {
return { info: info, datos: extraerFilas(info), etiqueta: extraerEtiquetaTabla(info, i + 1) };
});
var margenesTexto = leerMargenesTexto(docExterno);
crearWidget(grupos, margenesTexto, contenedor);
})
.catch(function (err) {
console.warn("Calculadora de tallas: no se pudo cargar la guía enlazada.", err);
});
});
}
function iniciar() {
try {
iniciarEnPagina();
} catch (e) {
console.warn("Calculadora de tallas: error en modo página (no afecta al modo producto).", e);
}
try {
iniciarRemoto();
} catch (e) {
console.warn("Calculadora de tallas: error en modo remoto.", e);
}
}
if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", iniciar);
} else {
iniciar();
}
})();